/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { log } from 'utils/logger';
import {
    AWARD_POINTS,
    ADD_REWARDS,
    SET_POINTS_FOR_CURRENT_MR_PROVIDER,
    REPLACE_POINTS_EARNED,
    AWARD_POINTS_WITH_REWARDS,
    RESET_POINTS_BAR,
    PERMIT_REWARDS
    // REMOVE_EXPANDED_MESSAGE
} from 'redux/actions/rewards';

/* ========== ~~~~~~~~~~ REWARDS : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const rewards = (state = {}, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case AWARD_POINTS:
            log("@@@ SETTING REWARDS STATUS: AWARD_POINTS @@@@", action.numberOfPoints);
            newState.status.pointsEarned += action.numberOfPoints;
            return newState;
        case ADD_REWARDS:
            log("@@@ SETTING REWARDS STATUS: ADD_REWARDS @@@@", action.numberOfRewards);
            newState.status.numberOfRewardsEarned += action.numberOfRewards;
            return newState;
        case SET_POINTS_FOR_CURRENT_MR_PROVIDER:
            log("@@@ SETTING REWARDS STATUS: SET_POINTS_FOR_CURRENT_MR_PROVIDER @@@@", action.provider, action.points);
            newState['status']['marketResearch'][action.contentId]['marketResearchProvider'] = action.provider;
            newState['status']['marketResearch'][action.contentId]['marketResearchPoints'] = action.points;
            // newState.status.marketResearchProvider = action.provider;
            // newState.status.marketResearchPoints = action.points;
            return newState;
        case REPLACE_POINTS_EARNED:
            log("@@@ SETTING REWARDS STATUS: REPLACE_POINTS_EARNED @@@@", action.newPointsEarnedValue);
            newState.status.pointsEarned = action.newPointsEarnedValue;
            return newState;
        case AWARD_POINTS_WITH_REWARDS:
            log("@@@ SETTING REWARDS STATUS: AWARD_POINTS_WITH_REWARDS @@@@", action);
            newState.status.pointsEarned += action.numberOfPoints;
            newState.status.numberOfRewardsEarned += action.numberOfRewards;
            newState.status.rewardEarnedPhase = action.numberOfRewards > 0 && action.rewardsPhase;
            // newState.status.showExpandedMessage = action.showExpandedMessage;
            return newState;
        case RESET_POINTS_BAR:
            newState.status.rewardEarnedPhase = false;
            return newState;
        case PERMIT_REWARDS:
            newState.status.rewardsPermitted = true;
            return newState;
        // case REMOVE_EXPANDED_MESSAGE:
        //     log("@@@ SETTING REWARDS STATUS: REMOVE_EXPANDED_MESSAGE @@@@", action);
        //     newState = JSON.parse(JSON.stringify(state));
        //     newState.status.showExpandedMessage = false;
        //     return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default rewards;